import React from 'react'

import ButtonCustom from '../../atoms/button/ButtonCustom'
import PaymentLines from '../../atoms/PaymentLines/PaymentLines'
import StatusBtn from '../../atoms/status/StatusBtn'

import styles from './index.module.scss'
import { formatCommonAmount } from '../../../util/formatAmount'

const PaymentData = [
	{
		data: 'Requested on',
		itemData: '2025-08-20',
	},
	{
		data: 'Invoice',
		itemData: 'INV-2001',
	},
	{
		data: 'Payment',
		itemData: 'P-1001',
	},
]

export default function Details({ data, onBack }) {
	return (
		<>
			<div className={styles.details}>
				<div className={styles.header}>
					<button className={styles.back} onClick={onBack}>
						<img src="/images/BackButton.svg" alt="BackButton" />
						Back
					</button>
				</div>
				<div className={styles.content}>
					<div className={styles.headingGroup}>
						<h1>Payment {data.payment_id}</h1>
						<p>Invoice: {data.invoice}</p>
					</div>
					<div className={styles.btnsGroup}>
						<ButtonCustom size="lg" variant="outlined">
							{' '}
							<img
								src="/images/Reminder.svg"
								alt="Reminder"
							/>{' '}
							Send Reminder
						</ButtonCustom>
						<ButtonCustom size="lg">
							{' '}
							<img
								src="/images/Invoice2.svg"
								alt="Invoice"
							/>{' '}
							Download Invoice
						</ButtonCustom>
					</div>
				</div>
				<div className={styles.paymentLising}>
					<div className={styles.paymentSummary}>
						<h2>Summary</h2>
						<div className={styles.paymentSummaryList}>
							<ul>
								<li>
									<span className={styles.label}>Party</span>
									<span className={styles.value}>
										{data.party}
									</span>
								</li>
								<li>
									<span className={styles.label}>Amount</span>
									<span className={styles.value}>
										{formatCommonAmount(data?.amount)}
									</span>
								</li>
								<li>
									<span className={styles.label}>
										Due Date
									</span>
									<span className={styles.value}>
										{data.due_date}
									</span>
								</li>
								<li>
									<span className={styles.label}>Status</span>
									<StatusBtn
										label={data.status}
										variant={
											data.status === 'Completed'
												? 'active'
												: data.status === 'Pending'
													? 'inprogress'
													: data.status === 'Charged'
														? 'pending'
														: 'active'
										}
									/>
								</li>
								<li>
									<span className={styles.label}>
										Invoice
									</span>
									<span className={styles.value}>
										{data.invoice}
									</span>
								</li>
							</ul>
						</div>
					</div>
					<div className={styles.paymentPaymentActivity}>
						<h2>Payment Activity</h2>
						<div className={styles.paymentPaymentActivityList}>
							<PaymentLines PaymentData={PaymentData} />
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
